export default __webpack_public_path__ + "static/media/icon-back.6a547a8e.svg";